import type { FieldSeasonData } from '@core/models/seasons';
import dayjs, { DATE_FORMATS } from '@utils/dateUtils';
import { createEntityAdapter } from 'redux-ngrx-entity';
import { createSelector } from 'reselect';
import type { BoundStore } from '../store';

const { selectAll } = createEntityAdapter<FieldSeasonData>().getSelectors();

export const selectActiveSeasons = createSelector(
  (state: BoundStore) => selectAll(state.seasons),
  (seasons) => {
    return seasons.filter((s) => s.season.active && !s.uploaded);
  }
);

export const selectInactiveSeasons = createSelector(
  (state: BoundStore) => selectAll(state.seasons),
  (seasons) => {
    return seasons.filter((s) => !s.season.active && !s.uploaded);
  }
);

export const selectUploadedSeasons = createSelector(
  (state: BoundStore) => selectAll(state.seasons),
  (seasons) => {
    return seasons.filter((s) => s.uploaded);
  }
);

export const selectSeason = createSelector(
  (state: BoundStore) => state.seasons.entities,
  (state: BoundStore) => state.seasons.selectedSeasonId,
  (seasons, selectedId) => {
    return selectedId ? seasons[selectedId] : undefined;
  }
);

export const selectRegionTreeReferenceDate = (state: BoundStore): string => {
  const season = selectSeason(state)?.season;

  return dayjs(season?.active === false ? season.end_date : undefined).format(
    DATE_FORMATS.USA_FORMAT
  );
};
